export default __webpack_public_path__ + "static/media/wernyhora.59145158.jpg";